import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { TvAlert, TvButton, TvDiv, TvH4, TvSmall } from "@trustvid/design-system";
import { VerifySelfSignup } from "../../../services/auth";
import { persistUserData } from "../../../utils/auth-helpers";
import { buildPostSignupPath } from "../../../utils/saasPostSignupPath";
import AuthSplitLayout from "./AuthSplitLayout";
import { AUTH_FEATURE_PANEL_HEADING } from "./loginPageContent";

export const VERIFY_EMAIL_REDIRECT_MS = 1200;

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Verifying your email...");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Verification token is missing.");
      return;
    }

    const verify = async () => {
      const response = await VerifySelfSignup(token);
      if (response?.error) {
        setStatus("error");
        setMessage(response.error);
        return;
      }

      const accountId = response?.user?.account?.id;
      if (response?.token && accountId) {
        localStorage.setItem("token", response.token);
        localStorage.setItem("accountId", String(accountId));
        localStorage.setItem("userType", "user");
        persistUserData(response.user);
        setStatus("success");
        setMessage("Email verified. Opening plans...");
        setTimeout(() => navigate(buildPostSignupPath(accountId)), VERIFY_EMAIL_REDIRECT_MS);
      } else {
        setStatus("error");
        setMessage("Verification failed. Please try again.");
      }
    };

    verify();
  }, [navigate, searchParams]);

  return (
    <AuthSplitLayout
      pageTestId="verify-email-page"
      cardTestId="verify-email-form-card"
      brandTestId="auth-platform-brand"
      showCardHeading={false}
      cardTitle="Verify your email"
      cardSubtitle="Completing verification secures your workspace and enables instant access."
      featurePanelHeading={AUTH_FEATURE_PANEL_HEADING}
    >
      <TvDiv className="tv-login-page__form" data-testid="verify-email-status-panel">
        <TvH4 className="tv-login-page__card-heading fw-bold text-dark mb-2">Email Verification</TvH4>
        <TvSmall className="text-muted d-block mb-3">
          Confirming your email helps us keep your AI workspace secure.
        </TvSmall>

        {status === "loading" ? <TvAlert color="info">{message}</TvAlert> : null}
        {status === "success" ? <TvAlert color="success">{message}</TvAlert> : null}
        {status === "error" ? <TvAlert color="danger">{message}</TvAlert> : null}

        {status === "error" ? (
          <TvDiv className="mt-3 d-grid">
            <Link to="/register">
              <TvButton color="primary" className="tv-login-page__submit">
                Back to Register
              </TvButton>
            </Link>
          </TvDiv>
        ) : null}

        <TvSmall className="text-muted d-block mt-3">If this issue continues, contact support.</TvSmall>
      </TvDiv>
    </AuthSplitLayout>
  );
};

export default VerifyEmail;
